import { Switch } from '@mui/material'

const OfoqIosSwitch = ({
  defaultValue,
  onChangeHandler,
  customStyle,
  disabled,
}) => (
  <Switch
    sx={[styles.switchBtn, customStyle]}
    checked={defaultValue}
    onChange={onChangeHandler}
    disabled={disabled}
  />
)

const styles = {
  switchBtn: {
    '&.MuiSwitch-root': {
      width: { xs: '40px', sm: '60px' },
      height: { xs: 20, sm: 30 },
      padding: 0,
      margin: { xs: '0 12px', sm: '0 16px' },
      objectFit: 'contain',
      borderRadius: '30px',
      overflow: 'hidden',
      backgroundColor: '#29cc8b',
    },

    '& .MuiSwitch-switchBase': {
      top: { xs: '-7px', sm: '-6px' },
      left: { xs: '-9px', sm: 'unset' },

      '&$checked': {
        color: 'primary.white',
        '& + $track': {
          backgroundColor: '#29cc8b',
          opacity: 1,
          border: 'none',
        },
      },
      '&$focusVisible $thumb': {
        color: '#29cc8b',
        border: '6px solid #fff',
      },
    },
    '& .MuiSwitch-thumb': {
      width: { xs: 16, sm: 24 },
      height: { xs: 16, sm: 24 },
      color: 'white',
    },
    '& .MuiSwitch-track': {
      borderRadius: 12,
      border: 'none',
      backgroundColor: '#98a9bc',
      opacity: 1,
    },
  },
}
export default OfoqIosSwitch
